import * as Yup from 'yup'
import { ErrorMessage, Form, Formik } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import { ROUTES_PATH } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import Button from '../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { exportKitDistributionReport, generateDropdownOptions } from '../../../utility/genricFunction'
import './kitDistributionReport.scss'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import { getBatchFromBranch, getKitDistributionReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

const KitDistributionReport = () => {
  const dispatch = useDispatch()

  const [showTable, setShowTable] = useState(false)
  const branches = useSelector((state) => state?.branch?.branchTableData)
  const batches = useSelector((state) => state?.reports?.batches)
  const reportData = useSelector((store) => store.reports.kitDistributionReportData)
  const { loading , pageDropDownLoading } = useSelector((state) => state?.reports)
  
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])
  const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches])

  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
    const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)

    const printRef = useRef(null)
  
  const [initialValues] = useState({
    branch: userRole == "branch" ? branchId : '',
    batch: '',
  })
  const validationSchema = Yup.object().shape({
    branch: Yup.string().required('Branch is required'),
    batch: Yup.string().required('Batch is required'),
  })

  const breadCrumbsArr = [
    {
      title: 'Kit Distribution Report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Kit Distribution Report',
      link: ROUTES_PATH.KIT_DISTRIBUTION_REPORT,
    },
  ]
  const columns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      style: { minWidth: '2rem' },
    },
    {
      field: 'studentCode',
      header: 'Student Code',
      filter: false,
      style: { minWidth: '8rem' },
    },
    {
      field: 'studentName',
      header: 'Student Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'materialNames',
      header: 'Material Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '20rem' },
    },
  ]    
  
  const handleDownloadPfd = useReactToPrint({
        content: () => printRef.current,
    });



  useEffect(()=>{
    if(userRole == "branch"){
      dispatch(getBatchFromBranch(branchId))
    }
  })

  const handleBranchChange = async (value, setFieldValue) => {
    setFieldValue('branch', value)
    dispatch(getBatchFromBranch(value))
  }

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> &&  <div className='kit-distribution-report-wrapper'>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => {
          setShowTable(true)
          dispatch(
            getKitDistributionReport({
              batchId: values.batch,
              branchId: values.branch,
            }),
          )
        }}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className='time-table-report-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
            <div className='time-table-report-main-div'>
              <div className='time-table-report-input-fields'>
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Branch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'branch'}
                    placeholder={'Select Branch'}
                    options={branchOption}
                    selectedValue={values.branch}
                    disabled={userRole == "branch"}
                    onChange={(e) => {
                      handleBranchChange(e.target.value, setFieldValue)
                    }}
                  />
                  <ErrorMessage name='branch' component='div' className='error-msg' />
                </div>
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Batch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'batch'}
                    placeholder={'Select Batch'}
                    options={batchOptions}
                    selectedValue={values.batch}
                    onChange={handleChange}
                  />
                  <ErrorMessage name='batch' component='div' className='error-msg' />
                </div>
                <div className='submit-btn-wrapper'>
                  <Button type='submit' customClassName={'tt-report-btn-submit'}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
            {showTable && (
              <div className='time-table-report-table-div'>
                <div className='export-option-wrapper'>
                  <div className='pdf-excel-export'>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={() =>
                        exportKitDistributionReport(reportData, columns)
                      }
                    ><SimCardDownloadIcon /></Button>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={handleDownloadPfd}
                    ><PrintIcon />
                    </Button>
                  </div>
                </div>

                <div className='printable-component' ref={printRef}>
                <ReportDataTable columns={columns} value={reportData} />
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>}
    </>
  )
}

export default KitDistributionReport
